import { render, staticRenderFns } from "./AgingSkeleton.vue?vue&type=template&id=34ed0fff&scoped=true"
import script from "./AgingSkeleton.vue?vue&type=script&lang=js"
export * from "./AgingSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AgingSkeleton.vue?vue&type=style&index=0&id=34ed0fff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed0fff",
  null
  
)

export default component.exports